function auth(request, callback) {
  return fetch('/api/auth', {
    method: 'POST',
    headers: {
      'accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  })
  .then(response => { return response.json() })
  .then(callback);
}

const LoginAPI = { auth };
export default LoginAPI;
